import {numberFormat, priceFormat} from "@pg-mono/string-utils";

import {ICreditOffer} from "../types/ICreditOffer";

export const getSecondaryDataFromOffer = (offer: ICreditOffer) => {
    return [
        {
            title: "Całkowita kwota do spłaty",
            value: priceFormat(offer.max_loan_price + offer.sum_of_equal_interest)
        },
        {
            title: "Marża",
            value: numberFormat(offer.margin, {precision: 2, unit: "%", unitZero: "0%"})
        }
    ];
};
import {numberFormat, priceFormat} from "@pg-mono/string-utils";

import {ICreditOffer} from "../types/ICreditOffer";

export const getSecondaryDataFromOffer = (offer: ICreditOffer) => {
    return [
        {
            title: "Całkowita kwota do spłaty",
            value: priceFormat(offer.max_loan_price + offer.sum_of_equal_interest)
        },
        {
            title: "Marża",
            value: numberFormat(offer.margin, {precision: 2, unit: "%", unitZero: "0%"})
        }
    ];
};
